export const SCREENING_STATUSES = {
  NOT_STARTED: 'notStarted',
  NOT_READY: 'notReady',
  PENDING: 'pending',
  INCOMPLETE: 'incomplete',
  APPROVED: 'approved',
  APPROVED_WITH_CONDITIONS: 'approvedWithConditions',
  DECLINED: 'declined',
  CANCELED: 'canceled',
  ERROR: 'error',
  FAIL: 'fail',
};

export const POLLING_SCREENING_STATUSES = [SCREENING_STATUSES.PENDING];
export const SUBMITTED_SCREENING_STATUSES = [
  SCREENING_STATUSES.APPROVED,
  SCREENING_STATUSES.APPROVED_WITH_CONDITIONS,
  SCREENING_STATUSES.DECLINED,
  SCREENING_STATUSES.INCOMPLETE,
  SCREENING_STATUSES.ERROR,
];

export const SCREENING_STATUS_TO_DISABLE_BUTTON = [
  SCREENING_STATUSES.PENDING,
  SCREENING_STATUSES.NOT_READY,
];

export const SCREENING_POLL_INTERVAL = 2000;

export const SCREENING_ERROR_REGEX = {
  RENT_AMOUNT: /RentAmount must be/i,
  EMPLOYMENT_INCOME: /EmploymentIncome on/i,
  ADDRESS: /Address on/i,
  CITY: /City on/i,
  STATE: /State on/i,
  ZIP_CODE: /PostalCode on/i,
  APPLICANTS: /applicant\s+(\d+)/g,
};
